<template>
  <div class="flex-row">
    <div class="flex-col description-cell" :style="{ flex: '1 1 100%' }">
      <ul>
        <li v-if="specificConditionText" class="specific-condition-comment">
          <i class="v-icon material-icons">help_outline</i>
          <p class="base--text"> {{ specificConditionText }} </p>
        </li>
        <li class="ml-3 additional-description-comment">
          <i class="v-icon material-icons">info</i>
          <p v-read-more="{ maxLength: 230 }" class="read-more" ref="readMore">{{ info }} </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { ReadMoreDirective } from "@/utils/directives";

export default {
  props: {
    specificConditionText: {
      type: String,
      required: true
    },
    info: {
      type: String,
      required: true
    }
  },
  directives: {
    ReadMore: ReadMoreDirective
  },
}
</script>